export default __webpack_public_path__ + "static/media/logo-primary-color.67bddb89.png";